export default __webpack_public_path__ + "static/media/west-india-hoodie.41f1eff5.jpg";